# Quoi de neuf TeamTim ?

Ce document reprend de façon chronologique les mises à jour récentes de la plateforme TeamTim

## 25 Mars 2026

##### Règles employeur
  - Les formules de calcul des règles employeur peuvent désormais cibler des événements spécifiques. Cela permet, par exemple, de ne comptabiliser une durée (prestation, absence…) que sur les jours associés à un événement donné.
  - La liste des événements affiche désormais une colonne Règles employeur indiquant quelles règles référencent chaque événement.

---

## 20 Mars 2026

##### Missions internes à partir d'un horaire type (planning récurrent)
  - Création de missions internes à partir d'un horaire type qui se répète semaine après semaine, sans saisir chaque journée à la main.
  - Possibilité de définir une date de fin (mission à durée déterminée) ou de laisser la mission sans date de fin (mission sans échéance).
  - Les journées de travail à venir sont générées automatiquement à partir du masque hebdomadaire 
  - Vous pouvez toujours saisir les horaires manuellement jour par jour si vous préférez (limité à 1 an).

---

## 10 Mars 2026

##### Jours fériés et périodes spécifiques
  - Paramétrage des périodes spécifiques (jours fériés, fermetures exceptionnelles, etc.) par EU
  - Les jours fériés français sont pré-remplis par défaut ; possibilité d'ajouter des périodes personnalisées
  - Affichage des périodes spécifiques dans le récapitulatif : le nom des jours concernés apparaît dans l'en-tête de colonne de chaque jour (ex. « Lundi (1er janvier) »)

##### Règles employeur
  - Les totaux du récapitulatif peuvent désormais inclure certaines durées selon la configuration des règles (gérée par votre ETT). Les règles peuvent aussi être limitées aux jours fériés ou autres périodes spécifiques.

---

## 05 Mars 2026
 - Correction d’un bug qui empêchait l’affichage de tous les intérimaires disponibles lors de l’assignation à une demande.

---

## 25 Février 2026

##### Vue Paie
  - Correction des tooltips tronqués dans le tableau des semaines

---

## 29 Janvier 2026

- Amélioration du formulaire d'ajout d'événements de date à date pour les journées de travail
- Correction d'un bug qui perturbait l'ajout ou la modification d'adresse dans les paramètres d'une EU

---

## 28 Janvier 2026

##### Vue Paie
  - Inversion de l'ordre d'affichage : heures décimales en haut (en gras), heures au format HH:MM en bas
  - Correction du tri de la liste des salarié
  - Renommage de la colonne « Écart » en « A déduire » avec affichage uniquement des heures manquantes par rapport au contrat

---

## 26 Janvier 2026

##### Demande d'intérimaires
  - L'EU peut ajouter des catégories aux postes d'une demande d'intérimaires
  - L'ETT a accès aux catégories sur les missions, journées de travail et le récapitulatif

---

## 13 Janvier 2026

##### Qr Code
  - Correction d'un bug qui empêchait d'imprimer le QR code d'un salarié

---

## 8 Janvier 2026

##### Application mobile
  - Correction d'un bug qui empêchait de consulter la liste des notifications dans l'application mobile

---

## 18 Décembre 2025

##### Règle de pointage
  - Ajout d'une option "Fenêtre de pointage" sur les règles de pointage qui détermine à quel point un pointage peut être effectué avant le début ou après la fin de la journée de travail théorique.

##### Récapitulatif
  - Ajout de la colonne « Travaillé » dans les totaux du récapitulatif.

---

## 16 Décembre 2025

##### Règles employeur
  - Possibilité de limiter la période prise en compte par une règle afin de l’appliquer uniquement à certains jours de la semaine

---

## 26 Novembre 2025

##### Horaires contractuels pour les salariés
  - Possibilité d'ajouter les horaires contractuels aux salariés
  - Utilisation de la durée définie dans le contrat afin de déterminer combien d'heures doivent être comptabilisées pour une journée de travail avec un événement de type prestation
  - Si l'horaire n'est pas configuré, la durée théorique de la journée de travail est utilisée pour le calcul des journées de travail avec événements de type prestation 

---

## 18 Novembre 2025

##### Récapitulatif
  - L'export de date à date fonctionne désormais sans la limitation aux semaines complètes


##### Liste des missions
  - Amélioration de la vitesse de chargement de la liste des missions

---

## 10 Novembre 2025

##### Vue Paie
  - Suppression de colonnes inutiles pour faciliter la compréhension de l'affichage
  - Possibilité de voir les jours concernés par les événements prestations en survolant le total
  - Correction d'un bug où le total "Écart" n'était pas toujours correct
  - Les écarts sont affichés de façon plus visible grâce à un code couleur

##### Détails journée de travail
  - Pour alléger la page, les règles de pointage sont masquées par défaut

##### Gestion événements
  - Les événements ne peuvent plus être directement modifiés par les EU afin d'éviter des manipulations erronées qui affecteraient les coûts.
  - Correction du texte explicatif

##### Récapitulatif
  - Correction d'un bug avec les absences et présences dans le filtre Événements

---

## 04 Novembre 2025

##### Catégorisation des journées de travail
  - Les catégories peuvent 
    - être ajoutées de date à date pour les journées de travail non validées pour une même mission
    - être ajoutées lors de la création d'une mission d'un salarié et seront appliquées à toutes les journées de la mission
    - être créées directement depuis la page journées de travail ou création de mission
  - Les administrateurs des EU peuvent gérer les catégories dans la section des paramètres
  - Les catégories sont visibles dans le récapitulatif et dans l'export

---

## 03 Novembre 2025
  - Modification du tri de la liste des journées de travail
  - Correction d'un bug où certains mails concernant les demandes d'intérimaires étaient envoyés aux profils "Pointeur uniquement"
  - Affichage du total lors de la simulation d'une préfacturation à 3 chiffres après la virgule

---

## 28 Octobre 2025

##### Règles employeur
  - Ajout de la possibilité d'utiliser les heures du contrat pour calculer les règles employeurs

---

## 21 Octobre 2025

##### Vue Intérimaire / Salarié
  - Correction d'un bug où les données n'étaient pas rafraîchies après mise à jour

##### Vue Paie
  - Correction d'un bug où les heures pour les journées avec évènement prestation n'étaient pas correctement affichées
  - Amélioration de l'affichage

---

## 14 Octobre 2025

##### Vue Paie
  - Liste des salariés avec une visibilité claire du statut par rapport à la période sélectionnée (journées de travail à valider, période clôturable, période clôturée)
  - Ajout de filtres pour la liste des salariés
  - Affichage des semaines sous forme de tableau, permettant une visualisation plus simple, surtout pour de longues périodes
  
##### Interface
  - Correction du tri par nom de famille pour les listes d'intérimaires et de salariés
  - Corrections de textes  
  - Correction d'un bug d'affichage des coûts d'abonnement

---

## 29 Septembre 2025

##### Textes et dénominations
  - Le terme "Intitulé de poste" devient "Métier"
  - Le terme "Service" devient "Affectation"
  - Corrections d'autres textes pour plus de clarté

##### Financier
  - Tous les coûts sont désormais affichés avec trois chiffres après la virgule

##### Récapitulatif
  - Les pointages absents ET en retard selon la règle de pointage sont affichés en orange

---

## 23 Septembre 2025

##### Demandes d'intérimaires - Améliorations
  - Les historiques de changements dans les Demandes d'Intérimaires sont plus complets 
  - Les intervenants sur une Demande sont identifiés

##### Correction & Améliorations des pointages forcés
  - Correction d'un bug qui attribuait de façon incorrecte l'heure du pointage forcé
  - Amélioration de la gestion des pointages forcés sur les journées de travail chevauchant deux jours
  - Affichage et modification plus précis du pointage forcé

---

## 16 Septembre 2025

##### Vue Paie et compteurs
  - Gestion des compteurs directement lors de la clôture d'une semaine
    - Des heures peuvent être prises dans le compteur et considérées comme payées dans la semaine
    - Des heures peuvent être partiellement ou totalement envoyées vers les compteurs

---

## 4 septembre 2025
  - Correction d'un bug qui empêchait de modifier le rôle d'un gestionnaire d'une EU

---

## 20 Août 2025
  - Correction d'un bug où le bouton "Abandon" restait activé sur la page d'une journée de travail interrompue
    - Il n'est pas possible de mettre en abandon de poste une mission déjà interrompue
  - Affichage des colonnes "Mission interrompue" et "Mission abandonnée" dans le récapitulatif même en mode compact

---

## 19 Août 2025

##### Vue Paie et compteurs
  - Les compteurs comptabilisent les heures liées aux règles spécifiques de l'EU pour un salarié (ex: compteurs des heures supplémentaires)
    - Lorsqu'une semaine est validée les compteurs sont incrémentés
    - Des modifications manuelles peuvent être appliquées aux compteurs
    - Un historique complet est enregistré pour chaque compteur
  - Les semaines dans la vue paie (bi parti) peuvent maintenant être validées
    - Les journées de travail faisant partie d'une semaine validée ne peuvent plus être dévalidées et donc modifiées.
    - Les compteurs sont incrémentés

---

## 14 Août 2025

##### Demandes d'intérimaires - Améliorations
  - Ajout de la possibilité d'attribuer des intérimaires à plusieurs postes simultanément
  - Ajout de suggestions d'intérimaires ayant déjà effectué une mission similaire au poste

---

## 11 Août 2025
  - Correction d'un bug où des emails étaient envoyé à de mauvais profils pour les membres des EU

---

## 3 Juillet 2025

  - Correction d'un bug permettant de créer une Journée de Travail en double pour un même travailleur

---

## 25 Juin 2025

  - Correction du formatage des heures décimales pour certains champs des exports Excel et CSV

---

## 20 Juin 2025

  - Correction du comportement de certains champs de formulaires : l'utilisation de la touche Entrée ne soumet plus automatiquement les formulaires

##### Interruption de collaboration avec un travailleur
  - Lorsqu'un intérimaire interrompt sa collaboration avec son ETT, les membres de l'ETT sont notifiés par email
  - Lorsqu'un salarié interrompt sa collaboration avec son EU, les membres de l'EU sont notifiés par email
  - Les membres des ETT et EU peuvent, depuis les paramètres de notifications, choisir s'ils souhaitent recevoir cet email

##### Demandes de personnel
  - Réorganisation de l'affichage des postes de la demande
  - Simplification de la liste

##### Récapitulatif
  - Les travailleurs en retard sont affichés dans le récapitulatif via le code couleur orange sur la colonne "Débuté"

---

## 10 Juin 2025

##### Filtre "Poste" pour les ETT
  - Ajout du filtre "Poste" dans la liste des missions et dans le récapitulatif des ETT
    - Ce filtre est utilisable uniquement quand une seule EU est sélectionnée dans le filtre "Entreprises Utilisatrices"

##### Gestion du service par journée de travail
  - Le service peut maintenant être modifié par journée de travail
  - Le service assigné à la mission reste le service assigné par défaut aux journées de travail de la mission
  - Une mission peut donc contenir des journées de travail avec des services différents

##### Email lors d'une modification de mission
  - Contient maintenant le détail de la modification effectuée par l'employeur

##### Récapitulatif
  - Affichage du nom de la personne ayant validé au survol du bouton de validation d'une journée de travail

##### Correction bugs
  - Désactivation de l'autocomplétion du navigateur sur les champs de sélection avec recherche, afin d'éviter les erreurs de manipulation.
  - Lors d'une notification de l'application mobile, le badge de notification ne s'affichait pas toujours sur l'icone de TeamTim.

---

## 4 Juin 2025

 - Ajout des coûts totaux des règles employeurs dans les préfacturations et le récapitulatif pour les ETT

---

## 3 Juin 2025

 - Correction d'un bug où les règles employeurs n'étaient plus visibles dans les préfacturations pour les ETT

##### Gestion des événements prestations pour les missions intérimaires
  - Valorisation des journées de travail avec événements prestation
  - Amélioration de l'affichage du travail non effectif dans le récapitulatif

---  

## 2 Juin 2025

 - Nouveau filtre "Événements" pour le récapitulatif, le dashboard EU et la liste des journées de travail
 - Il est maintenant possible d'annuler un abandon de poste

--- 

## 28 Mai 2025

 - Lorsqu'un travailleur avec un compte déjà actif est invité par une EU ou ETT, l'association est automatiquement acceptée. Le travailleur peut toujours contrôler l'association via les paramètres de son compte

--- 

## 21 Mai 2025

##### Amélioration du récapitulatif

  - Ajout d'un bouton pour valider la semaine complète d'un travailleur 
  - Amélioration de l'affichage pour les travailleurs ayant plusieurs missions sur la semaine
  - Les jours ne contenant pas de journées de travail sont affichés de façon réduite en mode compact
  - Ajout d'une colonne avec le coût horaire
  - Le matricule a été ajouté à l'export

##### Travailleurs et collaborateurs

  - Les travailleurs & collaborateurs sont maintenant affichés avec le nom de famille avant le prénom

---

## 19 Mai 2025

  - Correction d'un bug qui empêchait, dans certains cas, de modifier les coefficients de coût travail temporaires

---

## 30 avril 2025

  - Correction d'un bug qui affichait de mauvaises données concernant les collaborations dans l'application mobile

---

## 22 Avril 2025

##### Gestion des coûts horaires intérimaires

  - Les EU peuvent désormais contrôler les coûts horaires des intérimaires par intitulé de poste en :
    - imposant l'utilisation du SMIC
    - définissant un coût horaire minimum et maximum
  - Les ETT doivent attribuer le coût horaire au poste lorsque l'EU a spécifié de ne pas utiliser le SMIC

##### Filtres

  - Ajout d'un bouton de réinitialisation sur tous les filtres

##### Intitulé de poste et services

  - Les EU peuvent désormais désactiver un intitulé de poste ou un service
  - Les éléments désactivés n'apparaissent plus dans les listes de sélection lors de la création ou modification d'une mission ou d'une demande d'intérimaires
  - Il est possible de réactiver un intitulé de poste ou un service à tout moment

##### Récapitulatif

  - Les travailleurs sont maintenant affichés par ordre alphabétique

---

## 15 Avril 2025
  
  - Les EU peuvent imprimer les QR codes des intérimaires ayant une mission en cours ou devant débuter dans les trois prochains jours.
  - Les EU peuvent gérer les collaborations avec les intérimaires ayant déjà effectué des missions au sein de leur structure.
  - Création d'une nouvelle page présentant les informations des intérimaires et salariés, accessibles aux EU et aux ETT.

##### Demandes de Personnel Intérimaires
 - Une ETT peut désormais déclarer qu'un Poste dans une Demande ne sera pas pourvu
 - Un Poste fermé par une ETT est notifié à l'EU ayant établi la Demande
 - Une EU, en concertation avec l'ETT, peut décider de réouvrir ce Poste
 - Une EU peut désormais Interrompre une Mission sans demander de Remplaçant et puis réouvrir le Poste 
 - Une Demande est désormais Complète quand tous les Postes sont pourvus, ou fermés par l'ETT

---

## 11 Avril 2025

  - Correction d'un bug au compteur de Demandes en Cours ETT ne prenant pas en compte certaines Demandes  
  - Amélioration de la page d'aide pour encourager les utilisateurs de la plateforme à contacter le support
  - Le planning de la vue Tableau de Bord est maintenant filtrable

---

## 10 Avril 2025

##### Interruption de Mission
  - Les Journées de Travail suivant l'interruption sont désormais complètement supprimées
  - Une Mission Interrompue avant son début ne contient donc plus aucune Journée de Travail
  - L'historique des Missions déjà Interrompues a été nettoyé 

##### Abandon de Poste
  - Les Journées de Travail suivant un Abandon de Poste sont désormais complètement supprimées
  - L'historique des Missions déjà en Abandon de Poste a été nettoyé 

##### Vues Détails de Mission et Journées de Travail
  - La vue Détails de Mission a été actualisée et offre plus de détails
  - La vue Journées de Travail a été actualisée et offre plus de détails

---

## 24 Mars 2025

  - Possibilité pour les ETT et EU de visualiser et d'imprimer les QR codes de leurs intérimaires/salariés

---

## 21 Mars 2025

##### Amélioration de la vue Abonnement
  - Simplification de l'interface
  - Renommage des libellés pour plus de clarté

---

## 20 Mars 2025

  - Renforcement de la validation des interactions utilisateur côté serveur

---

## 19 Mars 2025

  - Correction d'un bug pour les E.U. qui ne pouvaient suggérer dans leurs Demandes un Intérimaire n'ayant pas complété son profil

---

## 21 Février 2025

##### Adaptations au Récapitulatif pour les ETT et EU
  - Les colonnes Semaine Validée et Semaine Pré-facturée sont maintenant fixes
  - L'icône pour les événements de type Prestation est bleue
  - Correction d'un bug d'affichage lors de l'utilisation conjointe des filtres Semaine/Jour/Compact
  - La section Mission renseigne le nom de l'Employeur pour les EU 
  - La section Mission renseigne le nom du client pour les ETT
  - Les boutons pour les Journées de Travail non Validables sont plus discrets

##### Invitation des Travailleurs
  - Possibilité de modifier l'adresse email des travailleurs n'ayant pas encore activé leur compte

##### Vue Paie
  - Affichage des totaux en format décimal dans les tableaux de paie

---

## 20 Février 2025

  - Correction d'un bug permettant d'ajouter un événement à une Journée de Travail Validée
  - Ajustement des couleurs et contrastes de certains éléments difficilement lisibles 

---

## 18 Février 2025

##### Filtres
  - Nouveau filtre Employeur qui regroupe les anciens filtres Type de Contrat et Agence
  - Le filtre "Pré-Facturé" n'est plus sur "Non" par défaut

##### Validation des Journées de Travail
  - Une Journée de Travail **vide** ne peut plus être validée
  - Pour être Validable une Journée de Travail doit :
    - soit avoir un pointage d'entrée et sortie, manuel ou forcé
    - soit avoir un Evénement de type Informatif
    - soit avoir un Evénement de type Prestation
    - soit être Interrompue
    - soit être en Abandon de Poste
  
---

## 14 Février 2025

##### Adaptations au Récapitulatif pour les ETT et EU
  - En Mode Compact plusieurs missions d'une même personne peuvent être compactées sur une même ligne
  - Désactiver le Mode Compact affiche le détail des missions, une par ligne 
  - Valider une Journée de Travail n'exige plus de double confirmation
  - L'indicateur de statut Semaine Validée est plus visible
  - L'indicateur de statut Semaine Préfacturée est plus visible
  - Le bouton pour dévalider une Journée de Travail est plus discret
  - Suppression du raccourci pour Interrompre une Mission
  - Suppression du raccourci pour Valider une Semaine
  - Filtrer par Journée n'affiche plus de lignes vides

---

## 13 Février 2025

  - Correction d'un bug lié à l'application rétro-active de Règles de Pointages sur des Journées de Travail existantes

---

## 11 Février 2025

  - Une EU peut maintenant configurer ses Services via les Paramètres  

---

## 10 Février 2025

  - Amélioration du filtre permettant d'afficher les Demandes d'Intérimaires expirées  

---

## 7 Février 2025

  - Correction d'un bug d'affichage sur des ordinateurs utilisant le mode sombre par défaut
  - Correction d'un bug lié au paramétrage des heures de jour et de nuit pour les EU
  - Correction d'un bug d'affichage de l'indicateur de statut de validation d'une Journée de Travail

---

## 5 Février 2025

  - Les bornes de scan se mettent à jour de façon automatique sans validation
  - Correction d'un bug empêchant l'envoi de Demandes impliquant des Intérimaires n'ayant pas complété leur profil

---